import { Row } from "react-bootstrap";
import { Select  } from 'antd';
import DatePicker from 'rsuite/DatePicker';
import { PlusCircleOutlined, CloseOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react";
import StorageService from "../../utils/storage.service";
import * as convert from "../constant/Convert.helper"
import { customStylesOption } from '../constant/GeneralData'
import { optionsMinuteBooking } from '../constant/GeneralData'
import { optionsSourceFrom, optionsProvince, customStylesFilterOption, hourSelect } from './constant/constant'
import { format } from "date-fns"
import _ from "lodash";
const { Option } = Select;

export default function Add(props) {
    const userLogin = JSON.parse(StorageService.getItem("user_info"));
    const [showPopupAddCategory, SetShowPopupAddCategory] = useState(false)
    const [bookHour, setBookHour] = useState(new Date().getHours())
    const [sourceFrom, setSourceFrom] = useState(optionsSourceFrom[0].value)
    const [province, setProvince] = useState()
    const [disableButtonAdd, setDisableButtonAdd] = useState(false)
    const [hour, setHour] = useState(hourSelect[(bookHour - 0)].value)
    const [minute, setMinute] = useState(0)
    const [nickName, setNickName] = useState('')
    const [date, setDate] = useState(new Date())
    const [category, setCategory] = useState([{ value: null,  label: null, product_id: null, product_name: null, product: null }])
    const [optionUser, setOptionUser] = useState([])
    const [userSelect, setUsersSelect] = useState({})
    const [defaultU, setDefaultU] = useState({value: userLogin.id, label: userLogin.name})

    const optionCategory = props.optionCategory

    useEffect(async () => {
        const listUser = props.listUser.filter(item => item.value !== 0);
        setOptionUser([...listUser])
        setUsersSelect({value: userLogin.id, label: userLogin.name})
    }, [])

    const onChangeHour = (event) => {
        setHour(event)
    }

    const onChangeMinute = (event) => {
        setMinute(event)
    }

    const onChangeDate = (event) => {
        setDate(event)
    }

    const onChangeCategory = (e, index) => {
        let listSelectedCat = category

        const cat = _.find(props.optionCategory, { value: e });
        listSelectedCat[index] = {...cat, product_id: null, product_name: null}

        setCategory([...listSelectedCat])
    }

    const onChangeProduct = (e, index) => {        
        let listSelectedCat = category
        let listOption = category[index].product
        const selected = _.find(listOption, { id: e });
        listSelectedCat[index] = {
            ...listSelectedCat[index],
            product_id: selected.id,
            product_name: selected.product_name
        }

        setCategory([...listSelectedCat])
    }

    const onChangeSourceFrom = (e) => {
        setSourceFrom(e)
    }

    const onChangeProvince = (e) => {
        setProvince(e)
    }
    const onChangeUser = (e) => {
        let row = {}
        for(let item of optionUser) {
            if (item.value == e) {
                row = item
            }
        }
        setUsersSelect({...row})
    }

    const onChangeNickName = (e) => {
        setNickName(e.target.value)
    }

    const addNewData = async (e) => {
        let book_hour = ("0" + hour).slice(-2),
            book_minute = ("0" + minute).slice(-2),
            book_date = convert.convertDate(date) + " " + [book_hour, book_minute].join(":");
            
        let onlineItems = []

        for (let item of category) {
            onlineItems.push({
                category_product_id: item.value,
                category_product_name: item.label,
                product_id: item.product_id ?? null,
                product_name: item.product_name ?? null,
            })
        }
        let data = {
            status: "Lead",
            online_date_start: new Date(book_date),
            nick_name: nickName,
            source_from: sourceFrom,
            province: province,
            sale_by: userSelect.value,
            sale_by_name: userSelect.label,
            onlineItem: onlineItems
        }

        if (nickName.length > 2) {
            props.addLead(data)
            props.close()
        }
    }

    const handleAddService = (y) => {
        category.push({
            value: null, 
            label: null,
            product_id: null,
            product_name: null,
            product: null
        })
        setCategory([...category])
    }

    const handleCancelService = (y) => {
        if (category.length > 1) {
            category.splice(y, 1);
            setCategory([...category])
        }
    }
    return (
        <div className="popup-cent">
            <div className="content-popup fadeInDown popup-view-services">
                <div className="head-popup">
                    <div className="title">Tạo lead</div>
                    <div className="close" onClick={props.close}>×</div>
                </div>
                <div className="body-popup">
                    <>
                        <div className="table-category_voucher create-data-sale">
                            <Row className="mt-4">
                                <div className="col-md-12 col-lg-10">

                                    <div className="items-data row">
                                        <div className="title col-3 col-md-2">Nick Name</div>
                                        <div className="value col-5 col-md-10">
                                            <input onChange={onChangeNickName} type="text" />
                                        </div>
                                    </div>
                                    <div className="items-data row pdt-10">
                                        <div className="title col-3 col-md-2">Giờ hẹn</div>
                                        <div className="value col-9 col-md-10">
                                            <div className="row">
                                                <div className="col-6 col-md-2 col-lg-2">
                                                    <Select className="select" onChange={onChangeHour} defaultValue={hourSelect[bookHour]} options={[...hourSelect]} />
                                                </div>
                                                <div className="col-6 col-md-2 col-lg-2">
                                                    <Select className="select" onChange={onChangeMinute} styles={customStylesOption} defaultValue={optionsMinuteBooking[0]} options={optionsMinuteBooking} />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-4" style={{ position: 'relative', zIndex: 1, top: '-3px' }}>
                                                    <DatePicker
                                                        onChange={onChangeDate}
                                                        className="custom-date-picker"
                                                        oneTap
                                                        format={'dd-MM-yyyy'}
                                                        defaultValue={new Date()}
                                                        placement={'bottomStart'}
                                                        size="sm"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {category.length > 0 ? 
                                        category.map((x,y) => {
                                            return (
                                                <div className="row" key={y} style={{marginBottom: "15px"}}>
                                                    <div className="title col-3 col-md-2" style={{color: "#5e6d8c", fontSize: "12px"}}>
                                                        {y === 0 ?  "Dịch vụ quan tâm" : null}
                                                    </div>
                                                    <div className="value col-9 col-md-10 select-option-one">
                                                        <Row>
                                                            <Select
                                                                className="col-5 select"
                                                                onChange={(e) => onChangeCategory(e, y)}
                                                                value={x}
                                                                options={optionCategory}
                                                            />
                                                            {x.product ? 
                                                                <Select
                                                                    showSearch
                                                                    optionFilterProp="children"
                                                                    className="select col-5"
                                                                    onChange={(e) => onChangeProduct(e, y)}
                                                                    value={x?.product_id}
                                                                >
                                                                    {x.product.map(x => {
                                                                        return (
                                                                            <Option key={x.id} value={x.id} >{x.product_name}</Option>
                                                                        )
                                                                    })}
                                                                </Select>
                                                            :null}
                                                            {x.value ? 
                                                                <div className="col-2 d-flex">
                                                                    <PlusCircleOutlined className="ml-3 mt-1"
                                                                        style={{ color: "green", fontSize: "18px", cursor: "pointer" }}
                                                                        onClick={() => { handleAddService(y) }}
                                                                    />
                                                                    {category.length > 1 ?
                                                                        <CloseOutlined className="ml-3 mt-1"
                                                                            style={{ color: "red", fontSize: "18px", cursor: "pointer" }}
                                                                            onClick={() => { handleCancelService(y) }}
                                                                        />
                                                                    :null}
                                                                    
                                                                </div>
                                                            :null}
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        
                                    :null}
                                    <div className="items-data row">
                                        <div className="title col-3 col-md-2">Nhân viên tư vấn</div>
                                        <div className="value col-9 col-md-10 select-option-one">
                                            <Select
                                                className="select"
                                                onChange={onChangeUser}
                                                defaultValue={defaultU}
                                                options={optionUser}
                                            />
                                        </div>
                                    </div>
                                    <div className="items-data row">
                                        <div className="title col-3 col-md-2">Nguồn đặt</div>
                                        <div className="value col-9 col-md-10 select-option-one">
                                            <Select
                                                className="select"
                                                onChange={onChangeSourceFrom}
                                                defaultValue={optionsSourceFrom[0]}
                                                options={optionsSourceFrom}
                                            />
                                        </div>
                                    </div>
                                    <div className="items-data row">
                                        <div className="title col-3 col-md-2">Tỉnh</div>
                                        <div className="value col-9 col-md-10 select-option-one">
                                            <Select
                                                showSearch
                                                optionFilterProp="label"
                                                className="select"
                                                onChange={onChangeProvince}
                                                value={province}
                                                placeholder="Chọn tỉnh"
                                                options={optionsProvince}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </div>
                    </>

                </div>
                {!showPopupAddCategory ?
                    <div className="bottom-popup">
                        <div className="button-container">
                            <div className="button-cent style3" onClick={props.close}>
                                <span><i className="fas fa-times"></i></span>Đóng
                            </div>
                            <div className={"button-cent"} onClick={disableButtonAdd ? () => {} : addNewData}>
                                <span><i className="fas fa-save"></i></span>Lưu thông tin
                            </div>
                        </div>
                    </div>
                    : null}
            </div>
            <div className="overlay" onClick={props.close}></div>
        </div>
    )
}
